import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Paper,
  styled,
  useMediaQuery,
  useTheme,
  Drawer,
  Container,
} from "@mui/material";
import { AppIcon } from "./app-icon";
import { Menu } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import AppLogo from '../assets/applogo.png';

const StyledListItem = styled(ListItem)(({ theme }) => ({
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.1)",
    },
    padding: "4px",
    cursor: "pointer",
    marginRight: 20,
}));

function NavBar() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { name: "Home", url: "/", same_page: true},
    { name: "Contact", url: "contact", same_page: true},
    { name: "Book Consultation", url: "/book-appointment", same_page: false},
    { name: "Metrics Calculator", url: "metrics-calculator", same_page: false},
    { name: "NutriAI", url: "nutri-ai", same_page: false},
    // { name: "Blog", url: "https://blog.nutriedu.com.ng", same_page: false},
    { name: "Student", url: "/students", same_page: false},
  ];

  const scrollToSection = (section) => {
    const element = document.getElementById(section);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
  

  const toggleMobileMenu = (open) => () => {
    setIsMobileMenuOpen(open);
  };

  return (
    <Container>
        <Paper
            sx={{
                display: "flex",
                flexDirection: "row",
                padding: 1.5,
                borderRadius: 8,
                boxShadow: "none",
                backgroundColor: "#dce6e6"
            }}
        >
        {/* App Icon */}
        <Box sx={{ display: "flex", alignItems: "center" }}>
            <img
                src={AppLogo}
            />
                
        </Box>

        {/* Desktop Menu */}
        <Box
            sx={{
            display: isMobile ? "none" : "flex",
            flexDirection: "row",
            alignItems: "center",
            flexGrow: 1,
            }}
        >
            <Box sx={{ flexGrow: 1 }}>
                <List
                    sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    paddingRight: 5,
                    width: 'fit-center'
                    }}
                    disablePadding
                >
                    {menuItems.map((item, index) => (
                    <StyledListItem key={index} disablePadding sx={{ width: "fit-content" }}
                        onClick={() => {
                            if (item.name === "Blog") {
                                window.open(item.url, "_blank");   
                            }
                            
                            else if (item.same_page) {
                                scrollToSection(item.url)
                            }
                            else {
                                navigate(item.url)
                            }
                        }}
                    >
                        <ListItemText primary={item.name} />
                    </StyledListItem>
                    ))}
                </List>
            </Box>
            {/* <Box>
            <Button variant="contained">Get Started!</Button>
            </Box> */}
        </Box>

        {/* Mobile Menu */}
        <Box
            sx={{
            display: isMobile ? "flex" : "none",
            flexGrow: 1,
            justifyContent: "flex-end",
            }}
        >
            <IconButton
            onClick={toggleMobileMenu(true)}
            sx={{
                "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
            }}
            >
            <Menu />
            </IconButton>
        </Box>

        {/* Drawer for Mobile Menu */}
        <Drawer
            anchor="right"
            open={isMobileMenuOpen}
            onClose={toggleMobileMenu(false)}
        >
            <Box
                sx={{
                    width: 250,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    padding: 2,
                }}
                role="presentation"
                onClick={toggleMobileMenu(false)}
                onKeyDown={toggleMobileMenu(false)}
            >
                <List sx={{ width: "100%" }}>
                    {menuItems.map((item, index) => (
                    <StyledListItem
                        key={index}
                        sx={{
                        justifyContent: "center",
                        marginBottom: 2, // Add spacing below each item
                        }}
                        onClick={() => {
                            if (item.name === "Blog") {
                                window.open(item.url, "_blank");   
                            }
                            else if (item.name === "Student") {
                                window.open(item.url, "_blank");   
                            }
                            else if (item.same_page) {
                                scrollToSection(item.url)
                            }
                            else {
                                navigate(item.url)
                            }
                        }}
                    >
                        <ListItemText
                        primary={item.name}
                        sx={{
                            textAlign: "center", // Center-align the text
                        }}
                        />
                    </StyledListItem>
                    ))}
                </List>
                {/* Push the Get Started button to the bottom */}
                {/* <Box sx={{ marginTop: "auto", padding: 2 }}>
                    <Button variant="contained" fullWidth>
                    Get Started!
                    </Button>
                </Box> */}
            </Box>
        </Drawer>
        </Paper>
    </Container>
  );
}

export default NavBar;
